/* eslint-disable no-restricted-globals */

export const STORAGE_KEYS = {
  DOCUMENT_REFERRER: 'DOCUMENT_REFERRER', // 접속 경로
  THROUGH_TAX_COMPANY_CODE: 'THROUGH_TAX_COMPANY_CODE', // 최초 접근 세무사 코드
  COMPANY_COMNUM: 'COMPANY_COMNUM', // 접근 회사 사업자번호
};

// 접속 경로 저장
export const setReferrer = (referrer) =>
  sessionStorage.setItem(STORAGE_KEYS.DOCUMENT_REFERRER, referrer)

// 접속 경로 가져오기 없으면 저장
export const getReferrer = (isForce = false) => {
  let referrer = sessionStorage.getItem(STORAGE_KEYS.DOCUMENT_REFERRER)
  if (!referrer && !isForce) {
    referrer = document.referrer
    setReferrer(referrer)
  }
  return referrer
}



// 최초 접근 세무사 코드 저장
export const setThroughTaxCompanyCode = (code) =>
  sessionStorage.setItem(STORAGE_KEYS.THROUGH_TAX_COMPANY_CODE, code)

// 최초 접근 세무사 코드 가져오기
export const getThroughTaxCompanyCode = () => {
  let throughTaxCompanyCode = sessionStorage.getItem(STORAGE_KEYS.THROUGH_TAX_COMPANY_CODE)
  const referrer = getReferrer(true)
  const code = location?.search?.split('?code=')[1]
  if (code && !throughTaxCompanyCode) {
    throughTaxCompanyCode = code
    setThroughTaxCompanyCode(code)
  }
  if (!throughTaxCompanyCode) {
    if (referrer && referrer.includes('https://wecake.io') && referrer.includes('https://www.wecake.io')) {
      // 온앤원 코드
      throughTaxCompanyCode = '4W4W4C'
    }

  }
  return throughTaxCompanyCode || ""
}



// 접근 사업자등록번호 저장
export const setCompnayNum = (comNum) =>
  localStorage.setItem(STORAGE_KEYS.COMPANY_COMNUM, comNum)

// 접근 사업자등록번호 가져오기
export const getCompnayNum = () => {
  let _comNum = localStorage.getItem(STORAGE_KEYS.COMPANY_COMNUM)
  const comNum = location?.search?.split('?comNum=')[1]
  if (comNum && !_comNum) {
    _comNum = comNum
    setCompnayNum(comNum)
  }
  return _comNum || ""
}


